import Component from './map'

export default Component